import { Icon } from "@chakra-ui/react"

export const EnvelopeIcon = (props: any) => (
  <Icon xmlns="http://www.w3.org/2000/svg" width="28" height="19" viewBox="0 0 28 19" {...props}>
    <g data-name="Group 1692">
      <g data-name="Group 1161">
        <g data-name="Group 1160">
          <path data-name="Path 562" d="M25.123 0h-22.7a2.423 2.423 0 00-2.42 2.422V16.45a2.423 2.423 0 002.42 2.422h22.7a2.424 2.424 0 002.42-2.422V2.421A2.424 2.424 0 0025.123 0zm-.316 1.614l-.323.269-9.751 8.121a1.5 1.5 0 01-1.921 0L3.06 1.883l-.323-.269zM1.614 2.779l7.943 6.618-7.943 5.286zm23.509 14.479h-22.7a.81.81 0 01-.791-.647l9.223-6.137.926.77a3.114 3.114 0 003.987 0l.926-.77 9.223 6.137a.808.808 0 01-.794.647zm.806-2.575l-7.945-5.286 7.945-6.618z" fill="#06bcc1"/>
        </g>
      </g>
    </g>
  </Icon>
);
